<div class="filter">
  <div>{{translateValue("Filter-by")}}</div>
  <ul class="filter-options">
    <li class="option" *ngFor="let option of filterOptions; let i = index" 
      [ngClass]="{'active': option.selected}" (click)="selectOption(i)">
      {{translateValue(option.label)}}
    </li>
  </ul>
</div>  